import { DosageFormModel } from "@admin/domain/products/models/edit/ProductSpecificationsModel";
import React from "react";
import convertToLanguageMap from "@admin/domain/languages/helpers";
import MultiLanguages from "@admin/components/MultiLanguage";
import Input from "@admin/components/Input";

export default function DosageForm({ dosageForm }: { dosageForm: DosageFormModel | null }) {
    const mapText = convertToLanguageMap(dosageForm?.texts || []);

    return (
        <div>
            <Input name={`specifications[dosage_form_id]`} defaultValue={dosageForm?.accounting_id} hidden={true} />
            <MultiLanguages
                languageElement={(language) => (
                    <Input
                        label="Форма выпуска"
                        name={`specifications[dosage_form][${language}]`}
                        defaultValue={mapText.get(language)?.title}
                        disabled={true}
                    />
                )}
            />
        </div>
    );
}
